export const GET_PROJECTS = "GET_PROJECTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const DELETE_PROJECT = "DELETE_PROJECT"; // add new types
export const UPDATE_PROJECT = "UPDATE_PROJECT"; // add new types